import styled from 'styled-components';

export const EmailSectionWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;

  div {
    display: flex;
    justify-content: flex-start;
    align-content: center;
    align-items: center;
    gap: 10px;
  }
`;
